import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { Glyph } from '../components/Glyph';
const usePasswordToggle = (hasPassword, eyeColor, eyeColorDisabled, iconStyle) => {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(prevState => !prevState);
    };
    const PasswordToggleIcon = () => (<Glyph name={showPassword ? 'visibility' : 'visibility_off'} size={30} color={hasPassword ? eyeColor : eyeColorDisabled} style={StyleSheet.flatten([styles.icon, iconStyle])} onPress={togglePasswordVisibility} disabled={!hasPassword}/>);
    return [showPassword, PasswordToggleIcon];
};
const styles = StyleSheet.create({
    icon: {
        marginLeft: 16,
    },
});
export default usePasswordToggle;
